import { makeStyles } from "@material-ui/core/styles"
import { green } from "@material-ui/core/colors"

const useStyles = makeStyles((theme) => ({
  avatar: {
    backgroundColor: theme.palette.primary.main,
  },
  circleLoading: {
    opacity: "70%",
    position: "absolute",
  },
  btnFullWidth: {
    width: "100%",
    minHeight: "40px",
    borderRadius: "12px",
    fontWeight: 500,
  },
  buttonsContainer: {
    backgroundColor: theme.palette.background100,
    minHeight: "72px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    gap: "8px",
    paddingTop: "16px",
    paddingBottom: "16px",
    paddingLeft: "24px",
    paddingRight: "24px",
  },
  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
  label: {
    color: theme.palette.neutral400,
    "& .MuiInputLabel-shrink": { textAlign: "center", width: "100%" },
    "& .MuiFormLabel-asterisk": {
      display: "none",
    },
  },
  button: {
    letterSpacing: "-0.25%",
    lineHeight: "24px",
    fontFamily: "Roboto",
    fontSize: "16px",
    textTransform: "none",
    minWidth: "100%",
    height: "56px",
    borderRadius: "12px",
    "@media (max-width: 768px)": {
      width: "100%",
    },
  },
  contactCard: {
    height: "auto",
    fontSize: "14px",
    "&:hover #messageActionsButton": {
      display: "flex",
      position: "absolute",
      top: 0,
      right: 0,
    },
    whiteSpace: "pre-wrap",
    backgroundColor: theme.palette.background300,
    color: theme.palette.neutral400,
    alignSelf: "flex-end",
    borderRadius: "12px",
    paddingLeft: "16px",
    paddingRight: "16px",
    paddingTop: "8px",
    justifyContent: "space-between",
    alignItems: "center",
  },
}))

export default useStyles
